<div class="header-container">
  <nb-icon class="toggle" (click)="toggleSidebar()" icon="menu-outline"></nb-icon>
  <img class="logo" (click)="navigateHome()" src="assets/img/logo.png" />
  <a class="irobot" (click)="navigateHome()">iRobot</a>
  <a class="app-name" (click)="navigateHome()">{{ title }}</a>
  <nb-actions size="small">
    <nb-action>
      <nb-user [nbContextMenu]="userMenu" name="{{ username }}" nbContextMenuTrigger="hover" shape="semi-round">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
